export default __webpack_public_path__ + "static/media/srectr-kit-set-00.5e2c0f77.png";